<template>
  <div :dir="currentDir" :class="{ rtl: currentDir === 'rtl' }">
    <MainLayout v-if="$route.name !== 'Login'">
      <router-view />
    </MainLayout>

    <router-view v-else />
  </div>
</template>

<script setup>
import MainLayout from "@/components/layout/MainLayout.vue";
import { computed, watchEffect, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useNotificationStore } from "@/stores/notification";
import { watch } from "vue";

// ===== RTL/LTR =====
const { locale } = useI18n();
const currentDir = computed(() => (locale.value === "ar" ? "rtl" : "ltr"));

watchEffect(() => {
  document.documentElement.dir = currentDir.value;
  document.documentElement.lang = locale.value;
  localStorage.setItem("locale", locale.value);
});

// ===== Notifications =====
const store = useNotificationStore();

watch(
  () => store.notifications,
  (newVal, oldVal) => {
    console.log("notifications changed", newVal);
  }
);
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;900&display=swap");

#app {
  font-family: "Tajawal", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.rtl {
  text-align: right;
}
</style>
